export default __webpack_public_path__ + "static/media/POLlogo.fe8e582a.png";